import { API } from '../constants/api-urls';
import axios from '../requester';

export const getProjects = async () => axios.get(API.PROJECTS_PATH);
export const updateProject = async (path, payload) =>
  axios.patch(`${API.PROJECTS_PATH}/${path}`, payload);
